<template>
  <div>
    <div class="input-group flex-nowrap">
      <div class="input-group-prepend">
      <span class="input-group-text">
        <font-awesome-icon icon="calendar-day" />
      </span>
      </div>
      <input ref="date"
             type="text"
             class="form-control w-25"
             :aria-label="$t('Scheduled date')"
      >
      <div class="input-group-prepend">
      <span class="input-group-text">
        <font-awesome-icon :icon="['far', 'clock']" />
      </span>
      </div>
      <input ref="time"
             type="text"
             class="form-control w-25"
             :aria-label="$t('Scheduled time')"
      >
    </div>
    <small class="text-danger d-block" v-if="errorMessage">
      {{ errorMessage }}
    </small>
  </div>

</template>

<script>
  export default {

    props: [
      'value',
      'errorMessage'
    ],

    data() {
      return {
        $date: null,
        $time: null,
      }
    },

    mounted() {
      const self = this;
      const locale = this.$root.locale;
      $(this.$refs.date).datetimepicker({
        format: 'L',
        locale
      }).on('dp.change', self.dateChanged);

      $(this.$refs.time).datetimepicker({
        format: 'LT',
        locale
      }).on('dp.change', self.dateChanged);

      //this.setDate(this.value||moment().add(24, 'hours').add(5, 'minutes'));
      this.setDate(this.value||moment().add(this.$root.hardcodedMap.MIN_SECONDS.pickup + 120, 'seconds'))
    },
    methods: {
      setDate(date) {
        const val = date ? moment(date) : null;
        $(this.$refs.date).data("DateTimePicker").date(val);
        $(this.$refs.time).data("DateTimePicker").date(val);
        // $(this.$refs.date).val(date ? moment(date).format(this.$root.datetimeFormat) : null).change()
      },
      dateChanged(e) {
        const date= $(this.$refs.date).val();
        const time= $(this.$refs.time).val();
        if(!date && !time) {
          this.$emit('input', '');
        } else if( date && time) {
          this.$emit('input', moment(date+' '+time, 'L LT').toISOString());
        } else {
          // a kaj sad?
        }
        this.$emit('not-complete', !date || !time)
      },
    },
    watch: {
      value(date) {
        this.setDate(date);
      }
    },
    beforeDestroy() {
      $(this.$refs.date).datetimepicker('destroy');
      $(this.$refs.time).datetimepicker('destroy');
    }
  }
</script>
